import { render, staticRenderFns } from "./ShopOwnerProfile.vue?vue&type=template&id=34f315f3&scoped=true&"
import script from "./ShopOwnerProfile.vue?vue&type=script&lang=ts&"
export * from "./ShopOwnerProfile.vue?vue&type=script&lang=ts&"
import style0 from "./ShopOwnerProfile.vue?vue&type=style&index=0&id=34f315f3&lang=scss&scoped=true&"
import style1 from "./ShopOwnerProfile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f315f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFileInput,VForm,VRadio,VRadioGroup,VTextField})
